// app/javascript/landing/sections/Services.tsx
import React from "react";
import { motion, Transition, Variants } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper/modules";

const transition: Transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants: Variants = {
  hidden: { filter: "blur(10px)", transform: "translateY(20%)", opacity: 0 },
  visible: { filter: "blur(0)", transform: "translateY(0)", opacity: 1 },
};

const services = [
  {
    title: "Capacitación",
    text: "Capacita a tus equipos simulando situaciones reales en un entorno virtual y seguro.",
    image: "/landing/services/capacitacion.png",
  },
  {
    title: "Marketing",
    text: "Transforma la manera de comunicar productos y proyectos con experiencias inmersivas.",
    image: "/landing/services/marketing.png",
  },
  {
    title: "Comunicación",
    text: "Herramientas interactivas para socializar proyectos e infraestructura.",
    image: "/landing/services/comunicacion.png",
  },
  {
    title: "Maquetas",
    text: "Maquetas físicas y digitales interactivas de alta calidad.",
    image: "/landing/services/maquetas.png",
  },
];

export function Services() {
  return (
    <motion.div
      className="x-bg-red-400 flex flex-col justify-center"
      initial="hidden"
      whileInView="visible"
      transition={{ staggerChildren: 0.1 }}
    >
      <div className="w-full max-w-6xl mx-auto lg:px-4 space-y-14">
        {/* Encabezado */}
        <div className="px-4 lg:px-0">
          <div className="text-center space-y-1">
            <motion.h2
              className="text-4xl md:text-5xl font-bold text-purple-3"
              transition={transition}
              variants={variants}
            >
              Servicios
            </motion.h2>

            <motion.p
              className="text-xl md:text-2xl text-purple-3"
              transition={transition}
              variants={variants}
            >
              Soluciones inmersivas aplicadas a tus proyectos
            </motion.p>
          </div>
        </div>

        {/* Carrusel de servicios */}
        <motion.div>
          <Swiper
            className="services-swiper"
            modules={[FreeMode, Pagination]}
            pagination={{ clickable: true }}
            grabCursor
            spaceBetween={16}
            slidesPerView={1.2} // mobile: 1 slide exacta
            centeredSlides={true} // sin centrado raro en mobile
            breakpoints={{
              640: {
                slidesPerView: 1.4,
                centeredSlides: true,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1.6,
                centeredSlides: true,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 1.8,
                spaceBetween: 24,
                centeredSlides: false,
                freeMode: {
                  enabled: true, // 👈 modo libre real
                  sticky: false, // no “salta” a la siguiente
                  momentum: true, // inercia suave
                },
              },
            }}
          >
            {services.map((service) => (
              <SwiperSlide key={service.title}>
                <div
                  className="select-none w-full h-[220px] sm:h-[260px] md:h-[320px]
                    rounded-2xl overflow-hidden relative border border-neutral-200
                    flex items-center justify-center text-center px-6
                  "
                  style={{
                    backgroundImage: `url(${service.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="space-y-4 md:space-y-6 flex flex-col items-center justify-center text-white">
                    <h3 className="text-xl md:text-3xl font-bold">
                      {service.title}
                    </h3>
                    <p className="text-sm md:text-base max-w-md">
                      {service.text}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </motion.div>
  );
}
